import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const textH1Variant = defineStyle({
  fontWeight: "400",
  fontSize: "24px",
  lineHeight: "32px",
});

const textH2Variant = defineStyle({
  fontWeight: "400",
  fontSize: "20px",
  lineHeight: "28px",
});

const textH3Variant = defineStyle({
  fontWeight: "400",
  fontSize: "18px",
  lineHeight: "24px",
});

const textLargeBoldVariant = defineStyle({
  fontWeight: "700",
  fontSize: "16px",
  lineHeight: "20px",
});

const textExtraLargeBoldVariant = defineStyle({
  fontWeight: "700",
  fontSize: "18px",
  lineHeight: "24px",
});

const textPreLargeBoldVariant = defineStyle({
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "20px",
});

const textLargeVariant = defineStyle({
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "20px",
});
const textMediumVariant = defineStyle({
  fontWeight: "400",
  fontSize: "15px",
  lineHeight: "20px",
});

const textSmallVariant = defineStyle({
  fontWeight: "400",
  fontSize: "13px",
  lineHeight: "16px",
});

const textExtraSmallVariant = defineStyle({
  fontWeight: "400",
  fontSize: "12px",
  lineHeight: "14px",
});

const text14 = defineStyle({
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "20px",
});

const variants = {
  h1: textH1Variant,
  h2: textH2Variant,
  h3: textH3Variant,
  extraLargeBold: textExtraLargeBoldVariant,
  largeBold: textLargeBoldVariant,
  preLargeBold: textPreLargeBoldVariant,
  large: textLargeVariant,
  medium: textMediumVariant,
  small: textSmallVariant,
  extraSmall: textExtraSmallVariant,
  text14: text14,
};

export const textTheme = defineStyleConfig({ variants });
